<!-- @format -->

<ng-container *ngIf="!!ratings?.length">
	<div
		class="hmf-mt-m-0 hmf-mt-xxxs hmf-mb-m hmf-mb-lg-0"
		[ngClass]="{ 'hmf-mt-lg-l': isHighlight }">
		@for (
			secondaryRating of ratings;
			track $index.toString() + secondaryRating.label;
			let index = $index
		) {
			<div
				class="category-rating-container rating"
				[ngClass]="{
					'hmf-display-flex hmf-flex-rows hmf-align-items-center rating':
						secondaryRating.type !== 'SLIDER',
					'hmf-mt-xxxs hmf-mt-lg-xs': index > 0
				}">
				@if (!!secondaryRating.label) {
					@if (secondaryRating.type === 'SLIDER') {
						<ng-container>
							<label
								[for]="'category-rating' + index"
								class="hmf-body-bold-m hmf-mb-0 hmf-text-transform-capitalzize slider-label hmf-mb-xxxs"
								>{{ secondaryRating.label }}</label
							>

							<input
								[id]="'category-rating' + index"
								class="category-rating-container-slider"
								type="range"
								[min]="secondaryRating.minValue"
								[max]="secondaryRating.maxValue"
								[value]="secondaryRating.value"
								aria-label="slider"
								disabled />

							<div class="hmf-display-flex hmf-justify-content-between hmf-mt-xxxs">
								<span
									class="hmf-mb-0 hmf-text-transform-capitalize hmf-legal-s min-label ellipsis hmf-text-align-left"
									>{{ secondaryRating.minLabel }}</span
								>
								<span
									class="hmf-mb-0 hmf-text-transform-capitalize hmf-legal-s min-label ellipsis hmf-text-align-center"
									>{{ secondaryRating.middleLabel }}</span
								>
								<span
									class="hmf-mb-0 hmf-text-transform-capitalize hmf-legal-s max-label ellipsis hmf-text-align-end"
									>{{ secondaryRating.maxLabel }}</span
								>
							</div>
						</ng-container>
					} @else {
						<ng-container #categoryRatingContent>
							<label
								[for]="'category-rating' + index"
								class="hmf-body-s hmf-mb-0 hmf-text-transform-capitalize slider-text"
								>{{ secondaryRating.label }}</label
							>

							<input
								[id]="'category-rating' + index"
								class="category-rating-container-slider"
								type="range"
								[min]="secondaryRating.minValue"
								[max]="secondaryRating.maxValue"
								[value]="secondaryRating.value"
								disabled
								aria-label="slider" />

							<label
								class="hmf-legal-s slider-text hmf-display-flex hmf-justify-content-flex-end hmf-mb-0">
								{{ secondaryRating.averageRating | number: '1.0-1' }} /
								{{ secondaryRating.valueRange }}
							</label>
						</ng-container>
					}
				}
			</div>
		}
	</div>
</ng-container>
